import axios from "axios";
import { createContext, useContext, useReducer } from "react";

const initialState = {
  user: JSON.parse(sessionStorage.getItem('user')) || null,
  isAuthenticated: !!sessionStorage.getItem('user'),
  admin: JSON.parse(sessionStorage.getItem('admin')) || null,
  isAdminAuthenticated: !!sessionStorage.getItem('admin'),
  allUsers: [],
  errorMessage: null,
  authIsLoading: false,
}

function reducer(state, action) {
  switch(action.type) {
    case 'loading':
      return {
        ...state,
        authIsLoading: true
      }

    case 'allUsers':
      return {
        ...state,
        allUsers: action.payload,
        authIsLoading: false
      }

    case 'updateUser':
      return {
        ...state,
        authIsLoading: false
      }

    case 'deleteUser':
      return {
        ...state,
        authIsLoading: false
      }

    case 'updateprofile':
      return {
        ...state,
        user: action.payload,
        isAuthenticated: true,
        authIsLoading: false
      }

    case 'login':
      return {
        ...state,
        user: action.payload,
        isAuthenticated: true,
        authIsLoading: false,
        admin: null,
        isAdminAuthenticated: false,
      }
    case 'adminLogin':
      return {
        ...state,
        admin: action.payload,
        isAdminAuthenticated: true,
        authIsLoading: false,
        user: null,
        isAuthenticated: false,
      }

    case 'logout':
      return {
        ...state,
        user: null,
        isAuthenticated: false,
        authIsLoading: false,
        admin: null,
        isAdminAuthenticated: false,
      }

      case "autherror":
        return {
            ...state,
            authIsLoading: false,
            errorMessage: action.payload
        }


    default:
      throw new Error("action unknown");
      

  }
}

const AuthContext = createContext();

const serverUrl = 'https://osdevhub.com/homify_backend/api';


function AuthProvider({children}){

  const [{user, admin, allUsers, isAuthenticated, isAdminAuthenticated, errorMessage, authIsLoading}, dispatch] = useReducer(reducer, initialState);

    async function updateUserStatus(id, data) {
      dispatch({ type: 'loading' });
      try {

        const response = await axios.patch(`${serverUrl}/userstatus/${id}`, data);
        if(response.data.message === "User updated successfully") {
          dispatch({
            type: 'updateUser',
          })
        }
      } catch (error) {
        dispatch({
          type: 'autherror',
          payload: error.response?.data?.message || error.message || 'Error fetching comments for property'
      });

      console.error(error);
        
      }

    }

    async function fetchAllUsers() {
        dispatch({
            type:'loading'
        })
        try {
            const response = await axios.get(serverUrl + '/allusers');
            if (response.data.message === 'Users retrieved successfully') {
                dispatch({
                    type: 'allUsers',
                    payload: response.data.data
                })
            }
        } catch (error) {
            dispatch({
                type: 'autherror',
                payload: 'there is an error fetching users'
            })
            console.error(error);
            
        }
    } 

   function logout() {
      sessionStorage.removeItem('user')
      dispatch({
        type: 'logout'
      })
    }

    async function updateProfile(id, formData) {
      dispatch({type: 'loading'})
      try {
        const response = await axios.patch(`${serverUrl}/users/${id}`, formData);
        if(response.data.message === "User updated successfully") {
          const userData = response.data.user

          console.log(userData);
          
              sessionStorage.setItem("user", JSON.stringify(userData))
          dispatch({
            type: 'updateprofile',
            payload: userData
          })
        }
      } catch (error) {
        console.error(error);
        dispatch({
          type: 'autherror',
          payload: 'Something went wrong'
        })
        
      }

    }
    
    async function adminLogin(formData) {
      dispatch({type: 'loading'})
      try {
        const response = await axios.post(`${serverUrl}/adminsignin`, formData);
        if(response.data.message === 'Login successful') {
          const userData = response.data.user
              sessionStorage.setItem("admin", JSON.stringify(userData))
          dispatch({
            type: 'adminLogin',
            payload: userData
          })
        }
      } catch (error) {
        console.error(error);
        dispatch({
          type: 'autherror',
          payload: 'Wrong email or password'
        })
        
      }

    }
    async function login(formData) {
      dispatch({type: 'loading'})
      try {
        const response = await axios.post(`${serverUrl}/signin`, formData);
        if(response.data.message === 'Login successful') {
          const userData = response.data.user
              sessionStorage.setItem("user", JSON.stringify(userData))
          dispatch({
            type: 'login',
            payload: userData
          })
        }
      } catch (error) {
        console.error(error);
        dispatch({
          type: 'autherror',
          payload: 'Wrong email or password'
        })
        
      }

    }

    async function signup(formData) {
      dispatch({type: 'loading'})
        try {
            const response = await axios.post(`${serverUrl}/register`, formData);
            console.log('Response received:', response.data);
      
            if(response.data.message === 'Success'){
              const userData = response.data.data
              sessionStorage.setItem("user", JSON.stringify(userData))
              dispatch({
                type: 'login',
                payload: userData
              })
            }
          } catch (error) {
            console.error(error);
                  dispatch({
          type: 'autherror',
          payload: 'Something went wrong'
        })
          }
    }

    async function deleteUser(id) {
        dispatch({
            type:'loading'
        })
        try {
        
            const response = await axios.delete(`${serverUrl}/user/${id}`);
            if (response.data.message === 'User deleted successfully') {
                dispatch({
                    type: 'deleteUser'
                })
            }
        } catch (error) {
            dispatch({
                type: 'autherror',
                payload: 'error'
            })
        }
    }



    return <AuthContext.Provider value={{
      signup, 
      login, 
      logout, 
      updateProfile, 
      fetchAllUsers,
      deleteUser,
      updateUserStatus,
      adminLogin,
      admin,
      isAdminAuthenticated,
      allUsers,
      authIsLoading, 
      user, 
      isAuthenticated, 
      errorMessage
      }}>
        {children}
    </AuthContext.Provider>
};

function useAuth() {
    const context = useContext(AuthContext);

    if(context === undefined) throw new Error("AuthContext was used outside AuthProvider");
    

    return context
}

export {AuthProvider, useAuth}